import React, { useState, useEffect, Fragment } from "react";
import { useDispatch } from "react-redux";
import { Table, Input, InputNumber, Popconfirm, Form, Tag } from "antd";
import updateCrossDockingVendor from "../../store/crossdocking/update/actions";
import deleteVendor from "../../store/crossdocking/delete/actions";

const EditableCell = ({
    editing,
    dataIndex,
    title,
    inputType,
    record,
    index,
    children,
    ...restProps
}) => {
    const inputNode =
        inputType === "number" ? <InputNumber min={0} max={1} /> : <Input />;

    return (
        <td {...restProps}>
            {editing ? (
                <Form.Item
                    name={dataIndex}
                    style={{
                        margin: 0,
                    }}
                    rules={[
                        {
                            required: true,
                            message: `Por favor completa ${title}!`,
                        },
                    ]}
                >
                    {inputNode}
                </Form.Item>
            ) : (
                children
            )}
        </td>
    );
};

const CrossDockingTable = ({ vendors, dataLoading }) => {
    const [form] = Form.useForm();
    const [data, setData] = useState([]);
    const [editingKey, setEditingKey] = useState("");

    const dispatch = useDispatch();

    useEffect(() => {
        setData(vendors);
    }, [vendors]);

    const isEditing = (record) => record.key === editingKey;

    const edit = (record) => {
        form.setFieldsValue({
            contact_name: "",
            email: "",
            vendor_name: "",
            active: 0,
            ...record,
        });
        setEditingKey(record.key);
    };

    const cancel = () => {
        setEditingKey("");
    };

    const parseBool = (v) => {
        if (v === 0) {
            return false;
        } else if (v > 0) {
            return true;
        }
    };

    const save = async (key) => {
        try {
            const row = await form.validateFields();
            const newData = [...data];
            const index = newData.findIndex((item) => key === item.key);

            if (index > -1) {
                const item = newData[index];
                newData.splice(index, 1, { ...item, ...row });
                setData(newData);
                setEditingKey("");
                const updatedObject = {
                    ...row,
                    vendor_id: item.vendor_id,
                    active: parseBool(row.active),
                };
                dispatch(updateCrossDockingVendor(updatedObject));
            } else {
                newData.push(row);
                setData(newData);
                setEditingKey("");
            }
        } catch (errInfo) {}
    };

    const handleDeleteVendor = (vendor_id) => {
        dispatch(deleteVendor(vendor_id));
    };

    const columns = [
        {
            title: "Marca",
            dataIndex: "vendor_name",
            key: "vendor_name",
            editable: true,
            render: (value) => {
                return <b style={{ fontWeight: "600" }}>{value}</b>;
            },
        },
        {
            title: "Email",
            dataIndex: "email",
            key: "email",
            editable: true,
            render: (value) => {
                return <b style={{ fontWeight: "600" }}>{value}</b>;
            },
        },
        {
            title: "Nombre Contacto",
            dataIndex: "contact_name",
            key: "contact_name",
            editable: true,
        },
        {
            title: "Estado",
            dataIndex: "active",
            key: "active",
            editable: true,
            render: (value) => {
                if (value) {
                    return <Tag color="green">Habilitada</Tag>;
                } else {
                    return <Tag color="red">Deshabilitada</Tag>;
                }
            },
        },

        {
            title: "Opciones",
            dataIndex: "operation",
            render: (_, record) => {
                const editable = isEditing(record);
                return editable ? (
                    <span>
                        <button
                            type="button"
                            onClick={() => save(record.key)}
                            style={{
                                marginRight: 8,
                            }}
                        >
                            Guardar
                        </button>
                        <Popconfirm title="Cancelar?" onConfirm={cancel}>
                            <a>Cancelar</a>
                        </Popconfirm>
                    </span>
                ) : (
                    <Fragment>
                        <a
                            disabled={editingKey !== ""}
                            onClick={() => edit(record)}
                        >
                            <strong>Editar</strong>
                        </a>
                        <Popconfirm
                            disabled={editingKey !== ""}
                            title="Estas seguro de eliminar este vendor ?"
                            okText="Eliminar"
                            cancelText="Cancelar"
                            okButtonProps={{ danger: true }}
                            onConfirm={() =>
                                handleDeleteVendor(record.vendor_id)
                            }
                        >
                            <a style={{ marginLeft: "1rem", color: "red" }}>
                                <strong>Eliminar</strong>
                            </a>
                        </Popconfirm>
                    </Fragment>
                );
            },
        },
    ];

    const setInputType = (dataIndex) => {
        if (dataIndex === "active") {
            return "number";
        }
        return "text";
    };

    const mergedColumns = columns.map((col) => {
        if (!col.editable) {
            return col;
        }

        return {
            ...col,
            onCell: (record) => ({
                record,
                inputType: setInputType(col.dataIndex),
                dataIndex: col.dataIndex,
                title: col.title,
                editing: isEditing(record),
            }),
        };
    });

    return (
        <Form form={form} component={false}>
            <Table
                components={{
                    body: {
                        cell: EditableCell,
                    },
                }}
                loading={dataLoading}
                bordered
                dataSource={data}
                columns={mergedColumns}
                rowClassName="editable-row"
                pagination={{
                    onChange: cancel,
                }}
            />
        </Form>
    );
};

export default CrossDockingTable;
